import { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { PageLink, PageTitle } from "../../core";
import { Order, OrderStatus7Days } from "src/app/models/Order";
import { format } from "date-fns";
import * as lc from "src/app/modules/localstorage/index";
import { Dropdown } from "react-bootstrap";
import ShippingLimitLabel from "../shiporder-export/order-list/components/ShippingLimitLabel";
import db, { createNotificationAnotherUser, createRef } from "src/db";
import * as Chat from "src/actions/chat";
import { useDispatch } from "react-redux";
import * as chatSlice from "src/app/modules/chat/redux/ChatSlice";
import { deleteItemListCIQ } from "src/app/modules/ciq/redux/CIQSlice";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import * as userServ from "src/db/serviceUser";
import SyncModal from "../shiporder-export/order-list/components/modal/SyncModal";
import SyncResultModal from "../shiporder-export/order-list/components/modal/SyncResultModal";
import ListComponent from "../../../components/list/NewList";
import PriorityCell from "../shiporder-export/order-list/table/columns/PriorityCell";
import { OrderSNCell } from "../shiporder-export/order-list/table/columns/OrderSNCell";
import { handleCIQ } from "../../ciq-management/ciq-list/core/_requests";
import { sendRequestRTSOrder } from "src/api/server/order";
import { UnifiedLoading } from "src/app/components/loading";
import { IResponseRTS, RTSOrderModal } from "./modal/OrderModal";
import { WarehouseNameCell } from "./cell/WarehouseCell";
import MarketplaceCell from "./cell/ShopCell";

type Columns<T> = {
  title: string;
  field: keyof T;
  value: (props: { value: any }) => JSX.Element | Promise<JSX.Element>;
};

const NewOrderPage = () => {
  const { t } = useTranslation();
  const [dataAccount, setDataAccount] = useState([] as any[]);
  const [filterAccount, setFilterAccount] = useState([] as any[]);
  const [filterShipment, setFilterShipment] = useState([] as any[]);
  const [listReady, setListReady] = useState<boolean>(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalSyncresOpen, setModalSyncresOpen] = useState(false);
  const [syncResult, setSyncResult] = useState<any>();
  const [isSync, setIsSync] = useState<boolean>(
    lc.getItemLC("isSync") === "false" || false
  );
  const [syncDate, setSyncDate] = useState<Array<string>>([]);
  const [rtsProcessing, setRTSProcessing] = useState(false);
  const [rtsResponse, setRtsResponse] = useState<IResponseRTS>();
  const warehouseNameCache = useRef<Map<string, string[]>>(new Map());

  const isMobileView = useMediaQuery({ query: "(max-width: 900px)" });
  const navigate = useNavigate();

  const usersBreadcrumbs: Array<PageLink> = [
    {
      title: t("Menu.Order"),
      path: "#",
      isSeparator: false,
      isActive: false,
    },
    {
      title: "",
      path: "",
      isSeparator: true,
      isActive: false,
    },
  ];

  // kolom default tabel di order page
  const defaultColumns: Columns<Order>[] = [
    {
      field: "marketplaceType",
      title: t("Marketplace.Menu.Marketplace"),
      value: (props: any) => {
        return (
          <MarketplaceCell
            marketplaceCode={props?.value}
            accountId={props?.row?.original?.account?.id}
            dataAccount={dataAccount}
          />
        );
      },
    },
    {
      field: "ordersn",
      title: t("OrderList.OrderNumber"),
      value: (props: any) => {
        const data = props.row.original;
        return (
          <div
            className={
              isMobileView
                ? "m-0 p-0 d-flex justify-content-end"
                : "m-0 p-0 h-auto d-flex align-items-center justify-content-start fw-bolder"
            }
          >
            <OrderSNCell {...props} orderData={data} />
          </div>
        );
      },
    },
    {
      field: "isPrepack",
      title: t("Value.Pack.ColumnHeader"),
      value: (props: any) => {
        const isPrepack = props.value;
        return (
          <>
            <div>
              <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                {props.value}
              </p>
              <p className="p-0 m-0">
                {isPrepack
                  ? t("Value.Pack.ColumnValue.isPrepack")
                  : t("Value.Pack.ColumnValue.nonPrepack")}
              </p>
            </div>
          </>
        );
      },
    },
    {
      field: "marketplaceOrderCreatedAt",
      title: t("OrderList.OrderTime"),
      value: (props: any) => {
        // Check if we have a valid date value
        const isValidDate = (date: any) => {
          if (!date) return false;
          const d = new Date(date);
          return !isNaN(d.getTime());
        };

        // Handle Firebase timestamp (with seconds)
        if (props?.value?.seconds) {
          const timestamp = new Date(props?.value?.seconds * 1000);
          return (
            <>
              <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                {format(timestamp, "dd/MM/yyyy")}
              </p>
              <p className="p-0 m-0">{format(timestamp, "HH:mm")}</p>
            </>
          );
        }

        // Handle standard date value
        else if (props?.value && isValidDate(props?.value)) {
          try {
            const date = new Date(props?.value);
            return (
              <>
                <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                  {format(date, "dd/MM/yyyy")}
                </p>
                <p className="p-0 m-0">{format(date, "HH:mm")}</p>
              </>
            );
          } catch (error) {
            console.error("Error formatting date:", error);
            return (
              <>
                <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                  -
                </p>
                <p className="p-0 m-0">-</p>
              </>
            );
          }
        }

        // No valid date available
        else {
          return (
            <>
              <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                -
              </p>
              <p className="p-0 m-0">-</p>
            </>
          );
        }
      },
    },
    {
      field: "marketplaceLogisticChannelParent",
      title: t("OrderList.Shipper"),
      value: (props: any) => {
        const label: string = props.cell.row.original.shippingLabel;
        return (
          <div>
            <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
              {props.value}
            </p>
            <p className="p-0 m-0">{label}</p>
          </div>
        );
      },
    },
    {
      field: "marketplaceWarehouseIds",
      title: "fulfillment",
      value: (props: any) => (
        <WarehouseNameCell
          ids={props?.value}
          isPrepack={props.cell.row.original.isPrepack}
          key={props.cell.row.original.id}
          cache={warehouseNameCache}
        />
      ),
    },
  ];

  // kolom default tabel di order page
  // tab ALL
  const columnsWithStatus: Columns<Order>[] = [
    {
      field: "marketplaceType",
      title: t("Marketplace.Menu.Marketplace"),
      value: (props: any) => {
        return (
          <MarketplaceCell
            marketplaceCode={props?.value}
            accountId={props?.row?.original?.account?.id}
            dataAccount={dataAccount}
          />
        );
      },
    },
    {
      field: "ordersn",
      title: t("OrderList.OrderNumber"),
      value: (props: any) => {
        const data = props.row.original;
        return (
          <div
            className={
              isMobileView
                ? "m-0 p-0 d-flex justify-content-end"
                : "m-0 p-0 h-auto d-flex align-items-center justify-content-start fw-bolder"
            }
          >
            <OrderSNCell {...props} orderData={data} />
          </div>
        );
      },
    },
    {
      field: "status",
      title: t("Common.Modal.Column.Header.Status"),
      value: (props: any) => {
        const propsData = props?.row?.original;
        const status = propsData?.status;
        const isPrepack = propsData?.isPrepack;
        const printed =
          propsData?.printedLabel ??
          propsData?.printedLabelAt ??
          propsData?.printedLabelLocatorCode;
        let displayStatus = " ";
        switch (status) {
          case OrderStatus7Days.Unpaid:
            displayStatus = t("OrderStatus7Days.Unpaid");
            break;
          case OrderStatus7Days.NewOrder:
            displayStatus = t("OrderStatus7Days.NewOrder");
            break;
          case OrderStatus7Days.ReadyToShip:
            if (isPrepack && printed) {
              displayStatus = t("OrderStatus7Days.ReadyToShipVPprinted");
            } else {
              displayStatus = t("OrderStatus7Days.ReadyToShip");
            }
            break;
          case OrderStatus7Days.Shipping:
            displayStatus = t("OrderStatus7Days.Shipping");
            break;
          case OrderStatus7Days.Completed:
            displayStatus = t("OrderStatus7Days.Completed");
            break;
          case OrderStatus7Days.ConfirmReceive:
            displayStatus = t("OrderStatus7Days.ConfirmReceive");
            break;
          case OrderStatus7Days.Cancelled:
            displayStatus = t("OrderStatus7Days.Cancelled");
            break;
          case OrderStatus7Days.InCancel:
            displayStatus = t("OrderStatus7Days.InCancel");
            break;
          case OrderStatus7Days.Return:
            displayStatus = t("OrderStatus7Days.Return");
            break;
          case OrderStatus7Days.Delivered:
            displayStatus = t("OrderStatus7Days.Delivered");
            break;
          default:
            displayStatus = status;
        }

        return (
          <div className="w-100 m-0 p-0 d-flex flex-column justify-content-center flex-wrap">
            <p
              className="w-100 p-0 m-0 flex-wrap text-wrap"
              style={{
                wordBreak: "break-word",
                whiteSpace: "normal",
                overflowWrap: "break-word",
              }}
            >
              {displayStatus}
            </p>
          </div>
        );
      },
    },
    {
      field: "isPrepack",
      title: t("Value.Pack.ColumnHeader"),
      value: (props: any) => {
        const isPrepack = props.value;
        return (
          <>
            <div>
              <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                {props.value}
              </p>
              <p className="p-0 m-0">
                {isPrepack
                  ? t("Value.Pack.ColumnValue.isPrepack")
                  : t("Value.Pack.ColumnValue.nonPrepack")}
              </p>
            </div>
          </>
        );
      },
    },
    {
      field: "marketplaceOrderCreatedAt",
      title: t("OrderList.OrderTime"),
      value: (props: any) => {
        // Check if we have a valid date value
        const isValidDate = (date: any) => {
          if (!date) return false;
          const d = new Date(date);
          return !isNaN(d.getTime());
        };

        // Handle Firebase timestamp (with seconds)
        if (props?.value?.seconds) {
          const timestamp = new Date(props?.value?.seconds * 1000);
          return (
            <>
              <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                {format(timestamp, "dd/MM/yyyy")}
              </p>
              <p className="p-0 m-0">{format(timestamp, "HH:mm")}</p>
            </>
          );
        }

        // Handle standard date value
        else if (props?.value && isValidDate(props?.value)) {
          try {
            const date = new Date(props?.value);
            return (
              <>
                <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                  {format(date, "dd/MM/yyyy")}
                </p>
                <p className="p-0 m-0">{format(date, "HH:mm")}</p>
              </>
            );
          } catch (error) {
            console.error("Error formatting date:", error);
            return (
              <>
                <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                  -
                </p>
                <p className="p-0 m-0">-</p>
              </>
            );
          }
        }

        // No valid date available
        else {
          return (
            <>
              <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                -
              </p>
              <p className="p-0 m-0">-</p>
            </>
          );
        }
      },
    },
    {
      field: "marketplaceLogisticChannelParent",
      title: t("OrderList.Shipper"),
      value: (props: any) => {
        const label: string = props.cell.row.original.shippingLabel;
        return (
          <div>
            <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
              {props.value}
            </p>
            <p className="p-0 m-0">{label}</p>
          </div>
        );
      },
    },
    {
      field: "marketplaceWarehouseIds",
      title: "fulfillment",
      value: (props: any) => (
        <WarehouseNameCell
          ids={props?.value}
          isPrepack={props.cell.row.original.isPrepack}
          key={props.cell.row.original.id}
          cache={warehouseNameCache}
        />
      ),
    },
  ];

  // kolom dengan kolom priority di order page
  // tab status new order dan processing
  const columnsWithPriority: Columns<Order>[] = [
    {
      field: "marketplaceType",
      title: t("Marketplace.Menu.Marketplace"),
      value: (props: any) => {
        return (
          <MarketplaceCell
            marketplaceCode={props?.value}
            accountId={props?.row?.original?.account?.id}
            dataAccount={dataAccount}
          />
        );
      },
    },
    {
      field: "ordersn",
      title: t("OrderList.OrderNumber"),
      value: (props: any) => {
        const data = props.row.original;
        return (
          <>
            <div
              className={
                isMobileView
                  ? "m-0 p-0 d-flex justify-content-end fw-bolder"
                  : "m-0 p-0 fw-bolder"
              }
              style={{ color: "#999999" }}
            >
              <OrderSNCell {...props} orderData={data} />
            </div>
          </>
        );
      },
    },
    {
      field: "isPrepack",
      title: t("Value.Pack.ColumnHeader"),
      value: (props: any) => {
        const isPrepack = props.value;
        const prepackPrintedLabelLocator =
          props?.row?.original?.printedLabelLocatorCode;
        return (
          <>
            <div>
              <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                {props.value}
              </p>
              <p className="p-0 m-0">
                {isPrepack
                  ? prepackPrintedLabelLocator
                    ? t("Value.Pack.ColumnValue.isPrepack") +
                      " & " +
                      t("Value.Pack.Printed")
                    : t("Value.Pack.ColumnValue.isPrepack")
                  : t("Value.Pack.ColumnValue.nonPrepack")}
              </p>
            </div>
          </>
        );
      },
    },
    {
      field: "marketplaceOrderCreatedAt",
      title: t("OrderList.OrderTime"),
      value: (props: any) => {
        // Check if we have a valid date value
        const isValidDate = (date: any) => {
          if (!date) return false;
          const d = new Date(date);
          return !isNaN(d.getTime());
        };

        // Handle Firebase timestamp (with seconds)
        if (props?.value?.seconds) {
          const timestamp = new Date(props?.value?.seconds * 1000);
          return (
            <>
              <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                {format(timestamp, "dd/MM/yyyy")}
              </p>
              <p className="p-0 m-0">{format(timestamp, "HH:mm")}</p>
            </>
          );
        }

        // Handle standard date value
        else if (props?.value && isValidDate(props?.value)) {
          try {
            const date = new Date(props?.value);
            return (
              <>
                <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                  {format(date, "dd/MM/yyyy")}
                </p>
                <p className="p-0 m-0">{format(date, "HH:mm")}</p>
              </>
            );
          } catch (error) {
            console.error("Error formatting date:", error);
            return (
              <>
                <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                  -
                </p>
                <p className="p-0 m-0">-</p>
              </>
            );
          }
        }

        // No valid date available
        else {
          return (
            <>
              <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                -
              </p>
              <p className="p-0 m-0">-</p>
            </>
          );
        }
      },
    },
    {
      field: "orderPriorityNumber",
      title: t("OrderList.PriorityNumber"),
      value: (props: any) => {
        return (
          <>
            <div
              className={
                isMobileView
                  ? "m-0 p-0 d-flex justify-content-end fw-bolder"
                  : "m-0 p-0 d-flex justify-content-start fw-bolder"
              }
            >
              <PriorityCell {...props} oldOrder={props.row.original} />
            </div>
          </>
        );
      },
    },
    {
      field: "shipByDate",
      title: t("OrderList.ShippingLimit"),
      value: (props: any) => {
        return (
          <div
            className={
              isMobileView
                ? "m-0 p-0 d-flex justify-content-end fw-bolder"
                : "m-0 p-0 d-flex justify-content-start fw-bolder"
            }
          >
            <ShippingLimitLabel shippingTimestamp={props.value} />
          </div>
        );
      },
    },
    {
      field: "marketplaceLogisticChannelParent",
      title: t("OrderList.Shipper"),
      value: (props: any) => {
        const label: string = props.cell.row.original.shippingLabel;
        return (
          <>
            <div>
              <p className="p-0 m-0 fw-bolder" style={{ color: "#999999" }}>
                {props.value}
              </p>
              <p className="p-0 m-0">{label}</p>
            </div>
          </>
        );
      },
    },
    {
      field: "marketplaceWarehouseIds",
      title: "fulfillment",
      value: (props: any) => (
        <WarehouseNameCell
          ids={props?.value}
          isPrepack={props.cell.row.original.isPrepack}
          key={props.cell.row.original.id}
          cache={warehouseNameCache}
        />
      ),
    },
  ];

  // useeffect digunakan untuk data filter by account dan by shipment di order page
  useEffect(() => {
    const getDataAccount = async () => {
      try {
        let tempData: any = [];
        let tempDataFilter: any = [];
        let query = db.collection("account").where("type", "!=", "whatsapp");

        let snapshot = await query
          .orderBy("type", "asc")
          .orderBy("name", "asc")
          .get();
        snapshot.forEach((doc) => {
          let obj = doc.data();
          obj["id"] = doc.id;
          tempData.push(obj);
          tempDataFilter.push({
            label: `${doc.data().type} - ${doc.data().name}`,
            value: `id_${doc.id}`,
          });
        });
        setFilterAccount(tempDataFilter);
        setDataAccount(tempData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    const getShipper = async () => {
      try {
        let shipperFilter = [] as any;
        let shipment = await db
          .collection("shipments")
          .where("isParent", "==", true)
          .orderBy("name", "asc")
          .get();

        shipment.forEach((doc) => {
          shipperFilter.push({
            label: doc.data().name,
            value: doc.data().name,
          });
        });
        setFilterShipment(shipperFilter);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getDataAccount();
    getShipper();
  }, []);

  // useeffect sebagai trigger ketika data filter account dan shipment sudah didapatkan
  useEffect(() => {
    if (filterAccount.length > 0 && filterShipment.length > 0) {
      setListReady(true);
    }
  }, [filterAccount, filterShipment]);

  const dispatch = useDispatch();

  const modalSyncresClose = () => {
    setModalSyncresOpen(false);
    lc.removeLC("isSync");
    lc.removeLC("isSyncInProgress");
    lc.removeLC("syncDate");
  };

  const syncing = (state: boolean) => {
    setIsSync(state);
    lc.setItemLC("isSync", JSON.stringify(state));
    const storedSyncDate = lc.getItemLC("syncDate");
    if (storedSyncDate) {
      try {
        const parsedSyncDate = storedSyncDate as Array<string>;
        const reformattedSyncDate = parsedSyncDate?.map((date: string) => {
          return date.replace(/\//g, "/");
        });
        console.log(
          "Data from SyncDate state di useeffect:",
          reformattedSyncDate
        );
        // Set syncDate to the retrieved value
        setSyncDate(reformattedSyncDate);
      } catch (error) {
        console.error("Error parsing or processing storedSyncDate:", error);
      }
    }
  };

  const openSyncModal = (syncRes: any, syncDate: Array<string>) => {
    setSyncResult(syncRes);
    const order: Array<any> = [];
    var totalOrdersAffc: number = 0;
    syncRes?.response?.map((resp: any) => {
      const objData = {
        account: createRef("account", resp.account),
        error: resp.error,
        totalSyncOrder: resp.totalNewOrder,
        totalUpdatedOrder: resp.totalUpdatedOrder,
      };
      order.push(objData);
      totalOrdersAffc += resp.totalNewOrder + resp.totalUpdatedOrder;
    });

    const toSendToNotif = {
      startTime: syncDate[0],
      endTime: syncDate[1],
      orders: order,
    };

    const reformattedProp: Array<string> = syncDate.map((date: string) => {
      return date.replace(/\//g, "/");
    });
    console.log(
      "Data to be set to SyncDate State from SyncModal:",
      reformattedProp
    );
    setSyncDate(reformattedProp);

    userServ.insertSyncResultNotification(
      lc.getItemLC(lc.LCName.UserID),
      toSendToNotif
    );

    lc.setItemLC("syncResult", JSON.stringify(syncRes));
  };

  const modalClose = () => setModalOpen(false);

  useEffect(() => {
    // Retrieve syncDate from local storage
    const storedSyncDate = lc.getItemLC("syncDate");
    if (storedSyncDate) {
      try {
        const parsedSyncDate = storedSyncDate as Array<string>;
        const reformattedSyncDate = parsedSyncDate?.map((date: string) => {
          return date.replace(/\//g, "/");
        });
        console.log(
          "Data from SyncDate state di useeffect:",
          reformattedSyncDate
        );
        // Set syncDate to the retrieved value
        setSyncDate(reformattedSyncDate);
      } catch (error) {
        console.error("Error parsing or processing storedSyncDate:", error);
      }
    }

    // Retrieve syncResult from local storage
    const storedSyncResult = lc.getItemLC("syncResult");
    if (storedSyncResult) {
      const parsedSyncResult = JSON.parse(storedSyncResult);
      console.log("Data from SyncResult state:", parsedSyncResult);
      // Set syncResult to the retrieved value
      setSyncResult(parsedSyncResult);
    }

    // Check if sync is in progress and open the modal
    const isSyncInProgress = lc.getItemLC("isSyncInProgress") === "true";
    if (isSyncInProgress) {
      setModalSyncresOpen(true);
    }
  }, []);

  const startDate = new Date(Date.now() - 90 * 24 * 60 * 60 * 1000);

  const closeDropdown = () => {
    const dropdown = document.querySelector(".dropdown-menu.show");
    if (dropdown) {
      dropdown.classList.remove("show");
    }
  };

  return (
    <>
      <PageTitle breadcrumbs={usersBreadcrumbs}>
        {t("OrderList.Title")}
      </PageTitle>

      {!listReady && <UnifiedLoading />}

      {listReady && (
        <ListComponent<Order>
          collection="orders"
          collectionGroup={false}
          tabs={[
            // All
            {
              label: t("OrderStatus7Days.All"),
              filter: [],
              sort: [],
              customColumns: columnsWithStatus,
            },
            // Unpaid
            {
              label: t("OrderStatus7Days.Unpaid"),
              filter: [
                {
                  field: "status",
                  type: "text",
                  value: OrderStatus7Days.Unpaid,
                  label: t("OrderStatus7Days.Unpaid"),
                },
              ],
              sort: [
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   label: t("Common.Column.CreatedAt"),
                //   direction: "asc",
                // },
              ],
            },
            // New Order
            {
              label: t("OrderStatus7Days.NewOrder"),
              filter: [
                {
                  field: "status",
                  type: "text",
                  value: OrderStatus7Days.NewOrder,
                  label: t("OrderStatus7Days.NewOrder"),
                },
              ],
              sort: [
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   label: t("Common.Column.CreatedAt"),
                //   direction: "asc",
                // },
                {
                  field: "orderPriorityNumber",
                  label: t("OrderList.PriorityNumber"),
                  direction: "desc",
                },
              ],
              customColumns: columnsWithPriority,
              customSelection: {
                headerSelection: true,
                rowSelection: true,
              },
              customAction: {
                headerTitle: t("Marketplace.Table.Header.Action"),
                value: (props: any) => {
                  const marketplace = props.row.original.marketplaceType;
                  const orderID: string = props.row.original.id;
                  async function buttonInitiateChatHandler() {
                    if (
                      marketplace === "tokopedia" ||
                      marketplace === "lazada"
                    ) {
                      const initiatedChat =
                        await Chat.createMessageInitiateChatMarketplace(
                          marketplace,
                          orderID
                        );
                      if (initiatedChat) {
                        const collaborationId = initiatedChat.collaborationId;
                        const roomId = initiatedChat.roomId;
                        const collab = await Chat.fetchCollaborationByID(
                          collaborationId
                        );

                        if (!collab) {
                          console.error("Error fetching collaboration data");
                          return;
                        }
                        dispatch(chatSlice.updateChatList(collab));
                        // dispatch(chatSlice.setSelectedChat(collab.id));
                        dispatch(chatSlice.setSelectedRoom(roomId));
                        dispatch(deleteItemListCIQ(roomId));
                        navigate(`/handled-customer`);
                        dispatch(
                          chatSlice.setOrderInitiateMessage(props.row.original)
                        );
                        if (
                          collab.company &&
                          collab.company?.id &&
                          collab.customer
                        ) {
                          createNotificationAnotherUser(collab);
                        } else {
                          dispatch(chatSlice.updateAllChatChatList(collab));
                        }
                      }
                    } else if (marketplace === "shopee") {
                      //shopee
                      let userSearchKey = props.row.original.buyerId.toString();
                      let collab =
                        (await Chat.fetchCollaborationByUserSearchKeys(
                          "shopee",
                          userSearchKey
                        )) as any;

                      if (!collab) {
                        console.log("Error fetching collaboration data");
                        const initiatedChat =
                          await Chat.createMessageInitiateChatMarketplace(
                            marketplace,
                            orderID
                          );
                        if (initiatedChat) {
                          const collaborationId = initiatedChat.collaborationId;
                          const roomId = initiatedChat.roomId;
                          collab = await Chat.fetchCollaborationByID(
                            collaborationId
                          );
                        }
                      }

                      const collabId = collab?.id.toString() ?? "";
                      const room = collab?.roomsModel?.filter(
                        (room: any) => room?.userSearchKey === userSearchKey
                      )[0];
                      const roomId = room?.id;
                      if (room.status === "queue") {
                        const handleCIQResult = await handleCIQ(
                          collabId.toString(),
                          roomId
                        );
                      }
                      dispatch(chatSlice.updateChatList(collab));
                      // dispatch(chatSlice.setSelectedChat(collabId.toString()));
                      dispatch(chatSlice.setSelectedRoom(roomId));
                      dispatch(deleteItemListCIQ(roomId));
                      navigate(`/handled-customer`);
                      dispatch(
                        chatSlice.setOrderInitiateMessage(props.row.original)
                      );
                      if (
                        collab.company &&
                        collab.company?.id &&
                        collab.customer
                      ) {
                        createNotificationAnotherUser(collab);
                      } else {
                        dispatch(chatSlice.updateAllChatChatList(collab));
                      }
                    }
                  }

                  return !isMobileView ? ( // Desktop view
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="secondary"
                        id="dropdown-basic"
                        data-testid="dropdownToggleAction"
                        className="px-2 py-1 fs-7 my-2"
                      >
                        {t("Marketplace.Table.Header.Action")}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="bg-light text-center">
                        <div>
                          <div className="dropdown-item btn btn-active-light btn-sm">
                            <button
                              type="button"
                              className="btn btn-sm"
                              disabled={rtsProcessing}
                              onClick={async () => {
                                closeDropdown();
                                setRTSProcessing(true);
                                const requestRTS = await sendRequestRTSOrder([
                                  orderID,
                                ]);
                                if (requestRTS?.statusCode === 200) {
                                  setRtsResponse(requestRTS?.data);
                                }
                                setRTSProcessing(false);
                              }}
                            >
                              {t("OrderList.Button.ArrangeShipment")}
                            </button>
                          </div>
                          <div className="dropdown-item btn btn-active-light btn-sm">
                            {marketplace === "tokopedia" ||
                            marketplace === "lazada" ||
                            marketplace === "shopee" ? (
                              <button
                                type="button"
                                className="btn btn-sm"
                                onClick={() => buttonInitiateChatHandler()}
                              >
                                {t("OrderList.Button.GoToChat")}
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-sm text-secondary"
                                aria-disabled
                              >
                                {t("OrderList.Button.GoToChat")}
                              </button>
                            )}
                          </div>
                          {/* {(props.row.original?.forwardError ||
                            props.row.original?.isForwardSuccess == null) && (
                            <div className="dropdown-item btn btn-active-light btn-sm">
                              <button
                                type="button"
                                className="btn btn-sm"
                                disabled={forwardProcessing}
                                onClick={async () => {
                                  closeDropdown();
                                  setForwardProcessing(true);
                                  const requestReforward = await reForwardOrder(
                                    props.row.original?.ordersn
                                  );
                                  if (requestReforward?.statusCode === 200) {
                                    toast(
                                      `${t("OrderList.ReForward.Success")}${
                                        props.row.original?.id
                                      }`,
                                      {
                                        type: "success",
                                        position: "top-center",
                                        autoClose: 4000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                      }
                                    );
                                  } else {
                                    toast(
                                      `${t("OrderList.ReForward.Failed")}${
                                        props.row.original?.id
                                      } Error: ${
                                        requestReforward?.error?.message
                                      }`,
                                      {
                                        type: "error",
                                        position: "top-center",
                                        autoClose: 4000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                      }
                                    );
                                  }
                                  setForwardProcessing(false);
                                }}
                              >
                                {t("OrderList.ReForward")}
                              </button>
                            </div>
                          )} */}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  ) : (
                    // Mobile view
                    <Dropdown>
                      <Dropdown.Toggle
                        variant="transparent"
                        className="no-caret w-auto m-0 p-0"
                        bsPrefix="bi bi-three-dots-vertical text-primary fw-bolder fs-1 p-0 m-0"
                      ></Dropdown.Toggle>
                      <Dropdown.Menu>
                        <div>
                          <div className="dropdown-item btn btn-active-light btn-sm">
                            <button
                              type="button"
                              className="btn btn-sm"
                              disabled={rtsProcessing}
                              onClick={async () => {
                                closeDropdown();
                                setRTSProcessing(true);
                                const requestRTS = await sendRequestRTSOrder([
                                  orderID,
                                ]);
                                if (requestRTS?.statusCode === 200) {
                                  setRtsResponse(requestRTS?.data);
                                }
                                setRTSProcessing(false);
                              }}
                            >
                              {t("OrderList.Button.ArrangeShipment")}
                            </button>
                          </div>
                          <div className="dropdown-item btn btn-active-light btn-sm">
                            {marketplace === "tokopedia" ||
                            marketplace === "lazada" ? (
                              <button
                                type="button"
                                className="btn btn-sm"
                                onClick={() => buttonInitiateChatHandler()}
                              >
                                {t("OrderList.Button.GoToChat")}
                              </button>
                            ) : (
                              <button
                                type="button"
                                className="btn btn-sm text-secondary"
                                aria-disabled
                              >
                                {t("OrderList.Button.GoToChat")}
                              </button>
                            )}
                          </div>
                          {/* {(props.row.original?.forwardError ||
                            props.row.original?.isForwardSuccess == null) && (
                            <div className="dropdown-item btn btn-active-light btn-sm">
                              <button
                                type="button"
                                className="btn btn-sm"
                                disabled={forwardProcessing}
                                onClick={async () => {
                                  closeDropdown();
                                  setForwardProcessing(true);
                                  const requestReforward = await reForwardOrder(
                                    props.row.original?.ordersn
                                  );
                                  if (requestReforward?.statusCode === 200) {
                                    toast(
                                      `${t("OrderList.ReForward.Success")}${
                                        props.row.original?.id
                                      }`,
                                      {
                                        type: "success",
                                        position: "top-center",
                                        autoClose: 4000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                      }
                                    );
                                  } else {
                                    toast(
                                      `${t("OrderList.ReForward.Failed")}${
                                        props.row.original?.id
                                      } Error: ${
                                        requestReforward?.error?.message
                                      }`,
                                      {
                                        type: "error",
                                        position: "top-center",
                                        autoClose: 4000,
                                        hideProgressBar: false,
                                        closeOnClick: true,
                                        pauseOnHover: true,
                                        draggable: true,
                                      }
                                    );
                                  }
                                  setForwardProcessing(false);
                                }}
                              >
                                {t("OrderList.ReForward")}
                              </button>
                            </div>
                          )} */}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  );
                },
              },
              customExtra: [
                {
                  label: t("OrderList.Button.ArrangeShipment"),
                  value: (props: any) => {
                    return (
                      <button
                        type="button"
                        className="btn btn-light-primary w-100 m-0"
                        disabled={
                          props.selectedItems.length <= 0 || rtsProcessing
                        }
                        onClick={async () => {
                          setRTSProcessing(true);
                          const requestRTS = await sendRequestRTSOrder(
                            props.selectedItems
                          );
                          if (requestRTS?.statusCode === 200) {
                            setRtsResponse(requestRTS?.data);
                          }
                          setRTSProcessing(false);
                        }}
                      >
                        {rtsProcessing ? (
                          <span
                            className="indicator-progress m-0 p-0"
                            style={{ display: "block" }}
                          >
                            <span className="spinner-border spinner-border-sm align-middle m-0 p-0"></span>
                          </span>
                        ) : (
                          t("OrderList.Button.ArrangeShipment")
                        )}
                      </button>
                    );
                  },
                },
                {
                  label: t("OrderList.Button.Sync"),
                  value(props) {
                    return !isSync ? (
                      <button
                        type="button"
                        className="btn btn-light-primary w-100"
                        onClick={() => setModalOpen(true)}
                      >
                        {t("OrderList.Button.Sync")}
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-light-primary w-100 m-0"
                        disabled={true}
                      >
                        <span
                          className="indicator-progress m-0 p-0"
                          style={{ display: "block" }}
                        >
                          <span className="spinner-border spinner-border-sm align-middle m-0 p-0"></span>
                        </span>
                      </button>
                    );
                  },
                },
                {
                  label: "total_order",
                  value: (props: any) => {
                    return (
                      <button className="btn btn-secondary text-gray-700">
                        <p className="m-0 p-0 fw-bolder">
                          {props?.data?.allCount ?? 0} {t("Menu.Order")}
                        </p>
                      </button>
                    );
                  },
                },
              ],
            },
            // Processing
            {
              label: t("OrderStatus7Days.Processing"),
              filter: [
                {
                  field: "status",
                  type: "text",
                  value: OrderStatus7Days.ReadyToShip,
                  label: t("OrderStatus7Days.Processing"),
                },
                {
                  type: "or",
                  filters: [
                    {
                      field: "isForwardSuccess",
                      type: "boolean",
                      value: false,
                      label: "forwardSuccess",
                    },
                    {
                      field: "isForwardSuccess",
                      type: "null",
                      label: "forwardSuccess",
                    },
                  ],
                },
                // {
                //   field: "isPrepack",
                //   type: "exception",
                //   value: true,
                //   label: "prepack",
                // },
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   type: "date-range",
                //   value: {
                //     startDate: startDate,
                //     endDate: new Date(),
                //   },
                //   label: "30 days ago",
                // },
              ],
              sort: [
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   label: t("Common.Column.CreatedAt"),
                //   direction: "asc",
                // },
                {
                  field: "orderPriorityNumber",
                  label: t("OrderList.PriorityNumber"),
                  direction: "desc",
                },
              ],
              customColumns: columnsWithPriority,
              // customAction: {
              //   headerTitle: t("Marketplace.Table.Header.Action"),
              //   value: (props: any) => {
              //     return !isMobileView ? (
              //       <div className="text-center">
              //         <Dropdown>
              //           <Dropdown.Toggle
              //             variant="secondary"
              //             id="dropdown-basic"
              //             data-testid="dropdownToggleAction"
              //             className="px-2 py-1 fs-7 my-2"
              //           >
              //             {t("Marketplace.Table.Header.Action")}
              //           </Dropdown.Toggle>
              //           <Dropdown.Menu className="bg-light text-center">
              //             <div className="dropdown-item btn btn-active-light btn-sm">
              //               <button
              //                 type="button"
              //                 className="btn btn-sm"
              //                 disabled={forwardProcessing}
              //                 onClick={async () => {
              //                   closeDropdown();
              //                   setForwardProcessing(true);
              //                   const requestReforward = await reForwardOrder(
              //                     props.row.original?.ordersn
              //                   );
              //                   if (requestReforward?.statusCode === 200) {
              //                     toast(
              //                       `${t("OrderList.ReForward.Success")}${
              //                         props.row.original?.id
              //                       }`,
              //                       {
              //                         type: "success",
              //                         position: "top-center",
              //                         autoClose: 4000,
              //                         hideProgressBar: false,
              //                         closeOnClick: true,
              //                         pauseOnHover: true,
              //                         draggable: true,
              //                       }
              //                     );
              //                   } else {
              //                     toast(
              //                       `${t("OrderList.ReForward.Failed")}${
              //                         props.row.original?.id
              //                       } Error: ${
              //                         requestReforward?.error?.message
              //                       }`,
              //                       {
              //                         type: "error",
              //                         position: "top-center",
              //                         autoClose: 4000,
              //                         hideProgressBar: false,
              //                         closeOnClick: true,
              //                         pauseOnHover: true,
              //                         draggable: true,
              //                       }
              //                     );
              //                   }
              //                   setForwardProcessing(false);
              //                 }}
              //               >
              //                 {t("OrderList.ReForward")}
              //               </button>
              //             </div>
              //           </Dropdown.Menu>
              //         </Dropdown>
              //       </div>
              //     ) : (
              //       <Dropdown>
              //         <Dropdown.Toggle
              //           variant="none"
              //           className="no-caret w-auto m-0 p-0"
              //           bsPrefix="bi bi-three-dots-vertical fs-1 pe-3"
              //         ></Dropdown.Toggle>
              //         <Dropdown.Menu>
              //           <div className="dropdown-item btn btn-active-light btn-sm">
              //             <button
              //               type="button"
              //               className="btn btn-sm"
              //               disabled={forwardProcessing}
              //               onClick={async () => {
              //                 closeDropdown();
              //                 setForwardProcessing(true);
              //                 const requestReforward = await reForwardOrder(
              //                   props.row.original?.ordersn
              //                 );
              //                 if (requestReforward?.statusCode === 200) {
              //                   toast(
              //                     `${t("OrderList.ReForward.Success")}${
              //                       props.row.original?.id
              //                     }`,
              //                     {
              //                       type: "success",
              //                       position: "top-center",
              //                       autoClose: 4000,
              //                       hideProgressBar: false,
              //                       closeOnClick: true,
              //                       pauseOnHover: true,
              //                       draggable: true,
              //                     }
              //                   );
              //                 } else {
              //                   toast(
              //                     `${t("OrderList.ReForward.Failed")}${
              //                       props.row.original?.id
              //                     } Error: ${requestReforward?.error?.message}`,
              //                     {
              //                       type: "error",
              //                       position: "top-center",
              //                       autoClose: 4000,
              //                       hideProgressBar: false,
              //                       closeOnClick: true,
              //                       pauseOnHover: true,
              //                       draggable: true,
              //                     }
              //                   );
              //                 }
              //                 setForwardProcessing(false);
              //               }}
              //             >
              //               {t("OrderList.ReForward")}
              //             </button>
              //           </div>
              //         </Dropdown.Menu>
              //       </Dropdown>
              //     );
              //   },
              // },
              customExtra: [
                // {
                //   label: t("OrderList.ForwardButton"),
                //   value(props: any) {
                //     return (
                //       <button
                //         type="button"
                //         className="btn btn-light-primary w-100 m-0"
                //         disabled={forwardProcessing}
                //         onClick={async () => {
                //           setForwardProcessing(true);
                //           const requestReforward =
                //             await sendRequestForwardOrder("READY_TO_SHIP");
                //           if (requestReforward?.statusCode === 200) {
                //             toast(
                //               `${t("OrderList.ReForward.Success")} Status : ${t(
                //                 "OrderStatus7Days.ReadyToShip"
                //               )} ${requestReforward?.data?.orders?.length} ${t(
                //                 "Menu.Order"
                //               )}`,
                //               {
                //                 type: "success",
                //                 position: "top-center",
                //                 autoClose: 4000,
                //                 hideProgressBar: false,
                //                 closeOnClick: true,
                //                 pauseOnHover: true,
                //                 draggable: true,
                //               }
                //             );
                //           } else {
                //             toast(
                //               `${t("OrderList.ReForward.Failed")} Status : ${t(
                //                 "OrderStatus7Days.ReadyToShip"
                //               )} Error: ${requestReforward?.error?.message}`,
                //               {
                //                 type: "error",
                //                 position: "top-center",
                //                 autoClose: 4000,
                //                 hideProgressBar: false,
                //                 closeOnClick: true,
                //                 pauseOnHover: true,
                //                 draggable: true,
                //               }
                //             );
                //           }
                //           setForwardProcessing(false);
                //         }}
                //       >
                //         {forwardProcessing ? (
                //           <span
                //             className="indicator-progress m-0 p-0"
                //             style={{ display: "block" }}
                //           >
                //             <span className="spinner-border spinner-border-sm align-middle m-0 p-0"></span>
                //           </span>
                //         ) : (
                //           t("OrderList.ForwardButton")
                //         )}
                //       </button>
                //     );
                //   },
                // },
                {
                  label: t("OrderList.Button.Sync"),
                  value(props) {
                    return !isSync ? (
                      <button
                        type="button"
                        className="btn btn-light-primary w-100"
                        onClick={() => setModalOpen(true)}
                      >
                        {t("OrderList.Button.Sync")}
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-light-primary w-100 m-0"
                        disabled={true}
                      >
                        <span
                          className="indicator-progress m-0 p-0"
                          style={{ display: "block" }}
                        >
                          <span className="spinner-border spinner-border-sm align-middle m-0 p-0"></span>
                        </span>
                      </button>
                    );
                  },
                },
                {
                  label: "total_order",
                  value: (props: any) => {
                    return (
                      <button className="btn btn-secondary text-gray-700">
                        <p className="m-0 p-0 fw-bolder">
                          {props?.data?.allCount ?? 0} {t("Menu.Order")}
                        </p>
                      </button>
                    );
                  },
                },
              ],
            },
            // Ready to Ship
            {
              label: t("OrderStatus7Days.ReadyToShip"),
              filter: [
                {
                  field: "status",
                  type: "text",
                  value: OrderStatus7Days.ReadyToShip,
                  label: t("OrderStatus7Days.ReadyToShip"),
                },
                {
                  field: "isForwardSuccess",
                  type: "boolean",
                  value: true,
                  label: "forwardSuccess",
                },
                {
                  field: "forwardError",
                  type: "null",
                  label: "forwardError",
                },
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   type: "date-range",
                //   value: {
                //     startDate: startDate,
                //     endDate: new Date(),
                //   },
                //   label: "30 days ago",
                // },
              ],
              sort: [
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   label: t("Common.Column.CreatedAt"),
                //   direction: "asc",
                // },
                {
                  field: "orderPriorityNumber",
                  label: t("OrderList.PriorityNumber"),
                  direction: "desc",
                },
              ],
              customColumns: [
                ...defaultColumns,
                {
                  field: "shipByDate",
                  title: t("OrderList.ShippingLimit"),
                  value: (props: any) => {
                    return (
                      <div
                        className={
                          isMobileView
                            ? "m-0 p-0 d-flex justify-content-end"
                            : "m-0 p-0 fw-bolder"
                        }
                      >
                        <ShippingLimitLabel shippingTimestamp={props.value} />
                      </div>
                    );
                  },
                },
              ],
            },
            // Shipping
            {
              label: t("OrderStatus7Days.Shipping"),
              filter: [
                {
                  field: "status",
                  type: "text",
                  value: OrderStatus7Days.Shipping,
                  label: t("OrderStatus7Days.Shipping"),
                },
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   type: "date-range",
                //   value: {
                //     startDate: startDate,
                //     endDate: new Date(),
                //   },
                //   label: "30 days ago",
                // },
              ],
              sort: [
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   label: t("Common.Column.CreatedAt"),
                //   direction: "desc",
                // },
              ],
            },
            // Completed
            {
              label: t("OrderStatus7Days.Completed"),
              filter: [
                {
                  field: "status",
                  type: "text",
                  value: OrderStatus7Days.Completed,
                  label: t("OrderStatus7Days.Completed"),
                },
              ],
              sort: [
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   label: t("Common.Column.CreatedAt"),
                //   direction: "desc",
                // },
              ],
            },
            // Cancelled
            {
              label: t("OrderStatus7Days.Cancelled"),
              filter: [
                {
                  field: "status",
                  type: "text",
                  value: OrderStatus7Days.Cancelled,
                  label: t("OrderStatus7Days.Cancelled"),
                },
              ],
              sort: [
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   label: t("Common.Column.CreatedAt"),
                //   direction: "desc",
                // },
              ],
            },
            // Return
            {
              label: t("OrderStatus7Days.Return"),
              filter: [
                {
                  field: "status",
                  type: "text",
                  value: OrderStatus7Days.Return,
                  label: t("OrderStatus7Days.Return"),
                },
              ],
              sort: [
                // {
                //   field: "marketplaceOrderCreatedAt",
                //   label: t("Common.Column.CreatedAt"),
                //   direction: "desc",
                // },
              ],
            },
          ]}
          columns={defaultColumns}
          selection={{
            headerSelection: false,
            rowSelection: false,
          }}
          defaultFilters={[]}
          defaultSorting={[
            {
              field: "marketplaceOrderCreatedAt",
              label: t("Common.Column.CreatedAt"),
              direction: "asc",
            },
          ]}
          useFilter={[
            {
              field: "account",
              type: "option",
              label: `${t("OrderList.Sync.Account")} Marketplace`,
              options: [
                {
                  label: `${t("Common.Input.Select")}${t(
                    "OrderList.Sync.Account"
                  )}`,
                  value: "option-title",
                },
                ...filterAccount.sort((a, b) =>
                  a.label.localeCompare(b.label, undefined, {
                    sensitivity: "case",
                  })
                ),
              ] as any,
              value: "option-title",
            },
            {
              field: "marketplaceOrderCreatedAt",
              type: "date-range",
              label: t("OrderList.OrderTime"),
              value: undefined,
            },
            {
              field: "marketplaceLogisticChannelParent",
              type: "option",
              label: t("OrderList.Shipper"),
              options: [
                {
                  label: t("Common.Placeholder.SelectShipper"),
                  value: "option-title",
                },
                ...filterShipment.sort((a, b) =>
                  a.label.localeCompare(b.label, undefined, {
                    sensitivity: "case",
                  })
                ),
              ],
              value: "option-title",
            },
            {
              field: "shippingLabel",
              type: "option",
              label: t("OrderList.Shipper.Mobile"),
              options: [
                {
                  label: t("Common.Placeholder.SelectLabelShipper"),
                  value: "option-title",
                },
                { label: "ECO", value: "ECO" },
                { label: "STD", value: "STD" },
                { label: "Economy", value: "Economy" },
                { label: "Regular", value: "Regular" },
                { label: "Standard", value: "Standard" },
                { label: "HALU", value: "HALU" },
                { label: "INSTANT", value: "INSTANT" },
                { label: "COL", value: "COL" },
                { label: "JTR", value: "JTR" },
                { label: "CARGO", value: "CARGO" },
                { label: "STANDARD", value: "STANDARD" },
                { label: "SAMEDAY", value: "SAMEDAY" },
                { label: "YES", value: "YES" },
                { label: "Instant", value: "Instant" },
                { label: "GOKIL", value: "GOKIL" },
                { label: "ECONOMY", value: "ECONOMY" },
              ],
              value: "option-title",
            },
          ]}
          searching={{
            field: "ordersn",
            useFirestore: true,
            value: "",
            caseSensitive: false,
          }}
          extra={[
            {
              label: t("OrderList.Button.Sync"),
              value(props) {
                return !isSync ? (
                  <button
                    type="button"
                    className="btn btn-light-primary w-100"
                    onClick={() => setModalOpen(true)}
                  >
                    {t("OrderList.Button.Sync")}
                  </button>
                ) : (
                  <button
                    type="button"
                    className="btn btn-light-primary w-100 m-0"
                    disabled={true}
                  >
                    <span
                      className="indicator-progress m-0 p-0"
                      style={{ display: "block" }}
                    >
                      <span className="spinner-border spinner-border-sm align-middle m-0 p-0"></span>
                    </span>
                  </button>
                );
              },
            },
            {
              label: "total_order",
              value: (props: any) => {
                return (
                  <button className="btn btn-secondary text-gray-700">
                    <p className="m-0 p-0 fw-bolder">
                      {props?.data?.allCount ?? 0} {t("Menu.Order")}
                    </p>
                  </button>
                );
              },
            },
          ]}
        />
      )}

      {/* modal */}
      {modalOpen && (
        <SyncModal
          isOpen={modalOpen} //buka SyncModal
          onClose={modalClose} //Tutup SyncModal
          onSync={syncing} //Proses Sync
          syncResult={openSyncModal} //Data Response
          onResultFinished={() => setModalSyncresOpen(true)}
          // syncDate={setSyncDateTime} //Data DateTime
        />
      )}

      {modalSyncresOpen && (
        <SyncResultModal
          isResultOpen={modalSyncresOpen} //Buka SyncResultModal
          isResultClose={modalSyncresClose} //Tutup SyncResultModal
          syncRes={syncResult} //Data Response
          syncDate={syncDate} //Data DateTime
        />
      )}

      {rtsResponse && (
        <RTSOrderModal
          isOpen={!!rtsResponse}
          responseRTS={rtsResponse}
          onClose={() => setRtsResponse(undefined)}
        />
      )}
    </>
  );
};

export default NewOrderPage;
